import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withDevtools, withCallState } from '@angular-architects/ngrx-toolkit';

interface SettingsState {
  loading: boolean;
}

const initialState: SettingsState = {
  loading: false,
};

const STORAGE_KEY = 'settings-state';

// Fonction pour charger depuis le localStorage
function loadFromStorage(): Partial<SettingsState> | null {
  if (typeof window === 'undefined') return null;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

// Fonction pour sauvegarder dans le localStorage
function saveToStorage(state: SettingsState): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        loading: state.loading,
      }),
    );
  } catch (error) {
    console.error('Failed to save filter state:', error);
  }
}

export const SettingsStore = signalStore(
  { providedIn: 'root' },
  withDevtools('settings'),
  withCallState({ collection: 'settings' }),
  withState(() => {
    // Charger l'état initial depuis le localStorage
    const stored = loadFromStorage();
    return stored ? { ...initialState, ...stored } : initialState;
  }),
  withMethods((store) => ({
    updateLoading(isLoading: boolean): void {
      patchState(store, (state) => {
        const newState = { loading: isLoading };
        // Sauvegarder après la mise à jour
        saveToStorage({ ...state, ...newState });
        return newState;
      });
    },
  })),
);
